import { useQuery } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";
import { QueryTypes } from "./shared";
import AlertDTO from "src/models/AlertDTO";

export const useGetPremierPlusAlertsQuery = (binId: number | null, from: string | null | undefined, to: string | null | undefined, options: QueryTypes = {}) => {
    const getPremierPlusAlertsQueryKey = "getPremierPlusAlertsQuery";

    const getPremierPlusAlertsQuery = useQuery<AlertDTO[]>({
        queryKey: [getPremierPlusAlertsQueryKey, binId, from, to],
        queryFn: async (q) => {
            if(binId == null){
                return [];
            }
            return await BinApiService.getPremierPlusAlerts(binId, from, to, q.signal);
        },
        enabled: binId != null && options.enabled,
        refetchOnWindowFocus: options.refetchOnWindowFocus,
        retry: options.retry,
    })

    return { getPremierPlusAlertsQueryKey, getPremierPlusAlertsQuery };

}